import withAuth from "../../helper/withAuth";
import Tournament from "../../components/Tournament";
import {Link, useLoaderData, redirect} from 'react-router-dom';
import HttpRequest from "../../services/Request";
import Cookies from 'js-cookie';
import Menu from "../../components/layout/Menu";
import HeaderMain from "../../components/layout/HeaderMain";

function Home() {
    const tournaments = useLoaderData();
    return <div className='p-3'>
        <HeaderMain />
        <Menu/>
        <div className='mt-3 shadow default-bg rounded-b-sm p-2 py-5 md:w-[95%] mx-auto'>
            <div>
                {tournaments.comingSoon.length > 0 && <>
                    <div className="flex items-center">
                        <div className="flex p-2 rounded-full bg-white">
                            <img src="/icons/red-clock.png" className="w-[40px]" alt=""/>
                        </div>
                        <p className="text-white text-bold text-[32px] mx-3">پیش رو</p>
                    </div>
                    <div className="mt-3 ">
                        {tournaments.comingSoon.map((tournament, index) => {
                            return <Link to={`/tournament/${tournament.id}`}>
                                <Tournament key={index} tournament={tournament}/>
                            </Link>
                        })}
                    </div>
                </>}
                {tournaments.all.length > 0 && <>
                    <div className="flex items-center mt-3">
                        <div className="flex p-2 rounded-full bg-white">
                            <img src="/icons/cup.png" className="w-[40px]" alt=""/>
                        </div>
                        <p className="text-white text-bold text-[32px] mx-3">مسابقات من</p>
                    </div>
                    <div className="mt-3">
                        {tournaments.all.map((tournament, index) => {
                            return <Link to={`/tournament/${tournament.id}`}>
                                <Tournament key={index} tournament={tournament}/>
                            </Link>
                        })}
                    </div>
                </>}
            </div>
        </div>
    </div>
}

export default withAuth(Home)


export async function HomePageLoader() {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/user/tournaments`, (res) => {
                data = res.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}